import { render, staticRenderFns } from "./Metricas.vue?vue&type=template&id=659fbcf3&"
import script from "./Metricas.vue?vue&type=script&lang=js&"
export * from "./Metricas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports